/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputMissionResult
 */
export interface InputMissionResult {
    /**
     * 
     * @type {number}
     * @memberof InputMissionResult
     */
    ammo?: number;
    /**
     * 
     * @type {number}
     * @memberof InputMissionResult
     */
    ammunitionStockItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof InputMissionResult
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof InputMissionResult
     */
    customTarget?: string;
    /**
     * 
     * @type {string}
     * @memberof InputMissionResult
     */
    customTargetType?: string;
    /**
     * 
     * @type {number}
     * @memberof InputMissionResult
     */
    droneStockItemId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InputMissionResult
     */
    shouldDeductDrone?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof InputMissionResult
     */
    tags?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof InputMissionResult
     */
    target?: number;
    /**
     * 
     * @type {string}
     * @memberof InputMissionResult
     */
    targetStatus: string;
    /**
     * 
     * @type {number}
     * @memberof InputMissionResult
     */
    targetType?: number;
}

/**
 * Check if a given object implements the InputMissionResult interface.
 */
export function instanceOfInputMissionResult(value: object): boolean {
    if (!('targetStatus' in value)) return false;
    return true;
}

export function InputMissionResultFromJSON(json: any): InputMissionResult {
    return InputMissionResultFromJSONTyped(json, false);
}

export function InputMissionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputMissionResult {
    if (json == null) {
        return json;
    }
    return {
        
        'ammo': json['ammo'] == null ? undefined : json['ammo'],
        'ammunitionStockItemId': json['ammunition_stock_item_id'] == null ? undefined : json['ammunition_stock_item_id'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'customTarget': json['custom_target'] == null ? undefined : json['custom_target'],
        'customTargetType': json['custom_target_type'] == null ? undefined : json['custom_target_type'],
        'droneStockItemId': json['drone_stock_item_id'] == null ? undefined : json['drone_stock_item_id'],
        'shouldDeductDrone': json['should_deduct_drone'] == null ? undefined : json['should_deduct_drone'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'target': json['target'] == null ? undefined : json['target'],
        'targetStatus': json['target_status'],
        'targetType': json['target_type'] == null ? undefined : json['target_type'],
    };
}

export function InputMissionResultToJSON(value?: InputMissionResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ammo': value['ammo'],
        'ammunition_stock_item_id': value['ammunitionStockItemId'],
        'comment': value['comment'],
        'custom_target': value['customTarget'],
        'custom_target_type': value['customTargetType'],
        'drone_stock_item_id': value['droneStockItemId'],
        'should_deduct_drone': value['shouldDeductDrone'],
        'tags': value['tags'],
        'target': value['target'],
        'target_status': value['targetStatus'],
        'target_type': value['targetType'],
    };
}

